import { AnyAction, combineReducers, Reducer } from "redux"
import _ from "lodash"
import { AddFormToCaseActionTypes } from "../../addFormToCase/state/addFormToCaseTypes"
import { FormTemplate } from "./formTemplateTypes"
import { INormalizedEntities } from "../../../app/appTypes"

type TByIdState = { [id: string]: FormTemplate }
type TAllIdsState = string[]

const byId: Reducer<TByIdState> = (state: TByIdState = {}, action: AnyAction): TByIdState => {

  switch (action.type) {
    case AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
      return action.payload.all.entities.formTemplates
    default:
      return state
  }
}

export const allIds: Reducer<TAllIdsState> = (state: TAllIdsState = [], action: AnyAction): TAllIdsState => {
  switch (action.type) {
    case AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
      return action.payload.all.result
    default:
      return state
  }
}

export const formTemplateEntityReducer: Reducer<INormalizedEntities<FormTemplate>> = combineReducers({
  byId,
  allIds
})

